import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const notFoundRoutes = {
  path: '/:pathMatch(.*)*',
  component: () => import('@/layouts/blank.vue'),
  meta: { i18n, titleKey: 'notFound.metaTitle' },
  children: [
    {
      path: '',
      name: 'not-found',
      component: () => import('./Error404.vue'),
    },
  ],
} satisfies RouteRecordRaw;
